



















import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

import VisTimeline from './VisTimeline.vue'

import SDK from '../../src/lib/sdk'


@Component({
  name: 'NVis',
  components: {
    VisTimeline
  },
})
// https://visjs.github.io/vis-timeline/docs/timeline/
export default class App extends Vue {
  @Prop() public serial: any

  public title: string = "----"
  public dialog: any = false
  public dialogCC: any = ""
  public packet: any = ""
  public dates: any = []
  public dataHeaders: any = [
    {text: 'IO', align: 'start', value: 'IO',},
    {text: 'HumanIO', value: 'HumanIO',},
    {text: 'HumanValue', value: 'HumanValue',},
    {text: 'Value', value: 'Value',},

  ]
  public toggleProgress: boolean = true

  public handleHover(item: any) {
    this.title = item.content
  }

  public handleClick(item: any) {
    if (item.oid && item.content != "LOGIN" && item.content != "PING") {
      this.dialogCC = ""
      this.dialog = true
      this.packet = item.packet
      SDK.log(item.oid).then((d: any) => {
        this.dialogCC = d.data
      }).catch((e: any) => {
        this.dialogCC = e.response.data.Error.split("\n")
      })
    } else if (item.content == "CONNECTION") {
      let deltaMin = (item.end - item.start) / 1000 / 60
      let deltaHr = deltaMin / 60
      alert(this.formatTimestamp(item.start) + " <> " + this.formatTimestamp(item.end)+"\n"+deltaMin.toFixed(2)+"m "+deltaHr.toFixed(2)+"h")
    }
  }

  private formatTimestamp(timestamp: string) {
    return new Date(timestamp).toUTCString()
  }
}
